import * as React from "react";
import { AlgoliaAnalytics } from "@grandvisionhq/analytics";
/* empty css                                */
import { ProductListingBlock } from "../../../../../../../../lib-components/ProductListingBlock/lib-components/ProductListingBlock/ProductListingBlock.js";
const ProductListingBlockWrapper = ({
  product,
  index,
  reimbursableLogos,
  addImpressionEvent,
  pushProductClickToDatalayer,
  isPriceSuffixEnabled,
  indexName
}) => {
  const onProductBlockClick = React.useCallback(
    (product2, index2, handleSearchAnalytics) => {
      handleSearchAnalytics(product2.objectID, index2);
      pushProductClickToDatalayer(product2, index2);
    },
    [pushProductClickToDatalayer]
  );
  return /* @__PURE__ */ React.createElement(AlgoliaAnalytics, null, (handleSearchAnalytics) => {
    return /* @__PURE__ */ React.createElement(
      ProductListingBlock,
      {
        className: "product-listing-product-block",
        listingProduct: product,
        onImpression: () => addImpressionEvent?.(product, index, indexName),
        onInteraction: () => onProductBlockClick(product, index, handleSearchAnalytics),
        reimbursableLogos,
        productLocation: "plp",
        isPriceSuffixEnabled
      }
    );
  });
};
export {
  ProductListingBlockWrapper
};
//# sourceMappingURL=ProductListingBlockWrapper.js.map
